import type { ChatMessage, ChatReplyPreview } from '../model/types';

export function buildForwardMessageText(message: ChatMessage): string | undefined {
  const author = message.authorName.trim() || 'Unknown';
  const body = message.text?.trim();

  if (body) {
    return `${author}\n${body}`;
  }

  if (message.attachments.length) {
    return author;
  }

  return undefined;
}

export function toMessageQuotePreview(message: ChatMessage): ChatReplyPreview {
  return {
    id: message.id,
    text: message.text,
    attachments: message.attachments,
    sender: message.authorId
      ? {
          id: message.authorId,
          firstName: message.authorName,
          lastName: '',
          username: message.authorName,
          accountType: '',
          avatarUrl: null,
        }
      : null,
  };
}
